import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Alert.module.css';
import { Dropdown, Modal, Button, FloatingLabel, Form } from 'react-bootstrap';
import modalStyles from '../ModalStyles.module.css';
import { isItemActivelySilenced, getAlertColorsAndIcon, formatCompletedDate, formatAlertDescription } from '../../utils/alertUtils';
import { formatDateWithFullMonth, formatTime } from '../../utils/dateUtils';

const AlarmSettingsModal = ({ settingsModal, onClose, handleAlertAction }) => {

    const { unitType, dateFormat } = useSelector((state) => state.userInfo);
    const patient = useSelector((state) => state.patient);

    let { icon } = getAlertColorsAndIcon(settingsModal.alert);

    return (
        <Modal
            show={settingsModal.open}
            onHide={onClose}
            centered
            className={styles.alarmOptionsModal}
        >
            <Modal.Header closeButton>
                <div className="subtitle-1">
                    Alarm Settings
                </div>
            </Modal.Header>
            <Modal.Body>
                <div styles={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div style={{ display: "flex" }}>
                        {icon}
                        <span className="subtitle-1" style={{ padding: "0 5px" }}>
                            {settingsModal.alert.alert_display_name ?? settingsModal.alert.alert_name}
                        </span>
                        {formatCompletedDate(settingsModal.alert, dateFormat)}
                    </div>
                    {`${String(settingsModal.alert.alert_priority).charAt(0).toUpperCase() + String(settingsModal.alert.alert_priority).slice(1)} Priority: ${formatAlertDescription(settingsModal.alert, unitType)}`}

                    <hr></hr>
                    <div className="subtitle-2">Alarm Settings</div>

                    <div className={styles.alarmOptionsItem}>
                        <div>
                            <span>Snooze Alarm</span>
                            Specify how long to mute this alarm for.
                        </div>
                        {!isItemActivelySilenced(settingsModal.alert) ?

                            <Dropdown className={modalStyles.DropdownButtonPrimary} style={{ height: '44px' }}>
                                <Dropdown.Toggle disabled={!patient.userSettingsForPatient?.alertAuthorized} id="custom-alert-dropdown" className={styles.detailDropdown}>
                                    Silence
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 15, '15 mins')}>15 mins</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 30, '30 mins')}>30 mins</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 45, '45 mins')}>45 mins</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 60, '1 hr')}>1 hr</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 120, '2 hrs')}>2 hrs</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 240, '4 hrs')}>4 hrs</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 360, '6 hrs')}>6 hrs</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleAlertAction(settingsModal.alert, 'silence', 1440, '24 hrs')}>24 hrs</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            :
                            <p style={{ display: "flex", flexDirection: "column", color: "#2A7F38", textAlign: "end" }}>
                                {`Snoozed until ${formatTime(settingsModal.alert.alert_silenceTimestamp)}`}
                                <span>{formatDateWithFullMonth(settingsModal.alert.alert_silenceTimestamp, dateFormat)}</span>
                            </p>
                        }
                    </div>
                    {settingsModal.alert.alert_category === "clinical" &&
                        <div className={styles.alarmOptionsItem}>
                            <div>
                                <span>Adjust threshold</span>
                                Adjust the threshold for this patient in their Care Program settings.
                            </div>
                            <button className={styles.alarmOptionsButton} onClick={() => handleAlertAction(settingsModal.alert, 'updateEnrollment')}>
                                Update Care Program
                            </button>
                        </div>
                    }
                    <div className={styles.alarmOptionsItem}>
                        <div>
                            <span>Report a technical issue</span>
                            If this alarm doesn’t look right, let us know.
                        </div>
                        <button className={styles.alarmOptionsButton} onClick={() => handleAlertAction(settingsModal.alert, 'report')}>
                            Report an issue
                        </button>
                    </div>
                    <div className={styles.alarmOptionsItem}>
                        <div>
                            <span>Clear alarm</span>
                            Remove this alarm if you don’t need to see it anymore. This action cannot be undone.
                            <u>This action cannot be undone</u>
                        </div>
                        <button
                            className={styles.alarmOptionsButton}
                            disabled={!patient.userSettingsForPatient?.alertAuthorized}
                            style={{ background: "#9F1919" }}
                            onClick={() => handleAlertAction(settingsModal.alert, 'clear')}
                        >
                            Clear
                        </button>
                    </div>
                    {settingsModal.alert.alert_subType === "calibration overdue" &&
                    <div className={styles.alarmOptionsItem}>
                        <div>
                            <span>Clear alarm and remove task</span>
                            This will clear the alarm and remove the calibration task for the patient.
                            <u>This action cannot be undone</u>
                        </div>
                        <button
                            className={styles.alarmOptionsButton}
                            disabled={!patient.userSettingsForPatient?.alertAuthorized}
                            style={{ background: "#9F1919" }}
                            onClick={() => handleAlertAction(settingsModal.alert, 'clearAndResolveTask')}
                        >
                            Clear alarm and task
                        </button>
                    </div>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AlarmSettingsModal;
